// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .friends_post {
     margin: 1rem 0;
     width: 100%;
     height: auto;
     background: #6C22A6;
     padding: 10px 15px;
     border-radius: 7px;
     box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
     gap: 2.5rem;
     color: white;
 }

 .friends_post .friend_post_top {
     display: flex;
     align-items: center;
     justify-content: space-between;
 }

 .friends_post .friend_post_top .img_and_name {
     display: flex;
     align-items: center;
     color: white
 }

 .friends_post .friend_post_top .img_and_name img {
     width: 45px;
     height: 45px;
     border-radius: 50%;
     object-fit: cover;
     object-position: center;
     margin-right: 8px;
     cursor: pointer;
 }

 .friends_post .friend_post_top .img_and_name .friends_name .friends_name {
     font-weight: bold;
     cursor: pointer;
     margin: 0;
     font-weight: 500;
 }

 .friends_post .friend_post_top .img_and_name .friends_name .friends_name:hover {
     text-decoration: underline;
     color: #eee;
 }

 .friends_post .friend_post_top .img_and_name .friends_name .time {
     font-size: 14px;
     color: #919191;
     margin: 3px 0;
 }

 .friends_post .friend_post_top .menu {
     width: 35px;
     height: 35px;
     border-radius: 50%;
 }

 .friends_post .friend_post_top .menu:hover {
     background: #efefef;
     cursor: pointer;
 }

 .friends_post .friend_post_top .menu i {
     line-height: 35px;
     margin-left: 8px;
     font-size: 18px;
 }

 .friends_post embed {
     padding: .5rem;
     width: 100%;
     height: 300px;
     object-fit: cover;
     object-position: center;
     border-radius: 5px;
 }

 .post_like {
    background-color:rgb(57, 167, 195);
    border-radius: 7px;


 }
 .post_like:hover {
    scale: 0.99 ;
    background-color:rgb(5, 202, 252);

 }

.post_like_icon{
    scale: 0.9;
}
 .post_liked_icon {
     scale: 1.5;
     /* transition: 3s ease-in-out; */

     /* color: blue; */
 }
 .post_disliked_icon {
    scale: 1.5;
    /* color: blue; */
}

 .post_dislike {
    background-color: rgb(57, 167, 195);
    border-radius: 7px;


 }
 .post_dislike:hover {
    scale: 0.99 ;
    background-color:rgb(5, 202, 252);

 }
 .post_liked {
    /* transition: 1s ease-in-out; */
    border-radius: 7px;

     background-color: greenyellow;
     box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(255, 254, 254, 0.3) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;

 }

 .post_disliked {
    /* transition: 1s ease-in-out; */
    border-radius: 7px;

    background-color: rgb(251, 29, 0);
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(255, 254, 254, 0.3) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;

 }`, "",{"version":3,"sources":["webpack://./src/components/PostSection/PostCard/PostCard.css"],"names":[],"mappings":"CAAC;KACI,cAAc;KACd,WAAW;KACX,YAAY;KACZ,mBAAmB;KACnB,kBAAkB;KAClB,kBAAkB;KAClB,wCAAwC;KACxC,WAAW;KACX,YAAY;CAChB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,8BAA8B;CAClC;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB;CACJ;;CAEA;KACI,WAAW;KACX,YAAY;KACZ,kBAAkB;KAClB,iBAAiB;KACjB,uBAAuB;KACvB,iBAAiB;KACjB,eAAe;CACnB;;CAEA;KACI,iBAAiB;KACjB,eAAe;KACf,SAAS;KACT,gBAAgB;CACpB;;CAEA;KACI,0BAA0B;KAC1B,WAAW;CACf;;CAEA;KACI,eAAe;KACf,cAAc;KACd,aAAa;CACjB;;CAEA;KACI,WAAW;KACX,YAAY;KACZ,kBAAkB;CACtB;;CAEA;KACI,mBAAmB;KACnB,eAAe;CACnB;;CAEA;KACI,iBAAiB;KACjB,gBAAgB;KAChB,eAAe;CACnB;;CAEA;KACI,cAAc;KACd,WAAW;KACX,aAAa;KACb,iBAAiB;KACjB,uBAAuB;KACvB,kBAAkB;CACtB;;CAEA;IACG,kCAAkC;IAClC,kBAAkB;;;CAGrB;CACA;IACG,YAAY;IACZ,iCAAiC;;CAEpC;;AAED;IACI,UAAU;AACd;CACC;KACI,UAAU;KACV,gCAAgC;;KAEhC,iBAAiB;CACrB;CACA;IACG,UAAU;IACV,iBAAiB;AACrB;;CAEC;IACG,mCAAmC;IACnC,kBAAkB;;;CAGrB;CACA;IACG,YAAY;IACZ,iCAAiC;;CAEpC;CACA;IACG,gCAAgC;IAChC,kBAAkB;;KAEjB,6BAA6B;KAC7B,4LAA4L;;CAEhM;;CAEA;IACG,gCAAgC;IAChC,kBAAkB;;IAElB,iCAAiC;IACjC,4LAA4L;;CAE/L","sourcesContent":[" .friends_post {\r\n     margin: 1rem 0;\r\n     width: 100%;\r\n     height: auto;\r\n     background: #6C22A6;\r\n     padding: 10px 15px;\r\n     border-radius: 7px;\r\n     box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);\r\n     gap: 2.5rem;\r\n     color: white;\r\n }\r\n\r\n .friends_post .friend_post_top {\r\n     display: flex;\r\n     align-items: center;\r\n     justify-content: space-between;\r\n }\r\n\r\n .friends_post .friend_post_top .img_and_name {\r\n     display: flex;\r\n     align-items: center;\r\n     color: white\r\n }\r\n\r\n .friends_post .friend_post_top .img_and_name img {\r\n     width: 45px;\r\n     height: 45px;\r\n     border-radius: 50%;\r\n     object-fit: cover;\r\n     object-position: center;\r\n     margin-right: 8px;\r\n     cursor: pointer;\r\n }\r\n\r\n .friends_post .friend_post_top .img_and_name .friends_name .friends_name {\r\n     font-weight: bold;\r\n     cursor: pointer;\r\n     margin: 0;\r\n     font-weight: 500;\r\n }\r\n\r\n .friends_post .friend_post_top .img_and_name .friends_name .friends_name:hover {\r\n     text-decoration: underline;\r\n     color: #eee;\r\n }\r\n\r\n .friends_post .friend_post_top .img_and_name .friends_name .time {\r\n     font-size: 14px;\r\n     color: #919191;\r\n     margin: 3px 0;\r\n }\r\n\r\n .friends_post .friend_post_top .menu {\r\n     width: 35px;\r\n     height: 35px;\r\n     border-radius: 50%;\r\n }\r\n\r\n .friends_post .friend_post_top .menu:hover {\r\n     background: #efefef;\r\n     cursor: pointer;\r\n }\r\n\r\n .friends_post .friend_post_top .menu i {\r\n     line-height: 35px;\r\n     margin-left: 8px;\r\n     font-size: 18px;\r\n }\r\n\r\n .friends_post embed {\r\n     padding: .5rem;\r\n     width: 100%;\r\n     height: 300px;\r\n     object-fit: cover;\r\n     object-position: center;\r\n     border-radius: 5px;\r\n }\r\n\r\n .post_like {\r\n    background-color:rgb(57, 167, 195);\r\n    border-radius: 7px;\r\n\r\n\r\n }\r\n .post_like:hover {\r\n    scale: 0.99 ;\r\n    background-color:rgb(5, 202, 252);\r\n\r\n }\r\n\r\n.post_like_icon{\r\n    scale: 0.9;\r\n}\r\n .post_liked_icon {\r\n     scale: 1.5;\r\n     /* transition: 3s ease-in-out; */\r\n\r\n     /* color: blue; */\r\n }\r\n .post_disliked_icon {\r\n    scale: 1.5;\r\n    /* color: blue; */\r\n}\r\n\r\n .post_dislike {\r\n    background-color: rgb(57, 167, 195);\r\n    border-radius: 7px;\r\n\r\n\r\n }\r\n .post_dislike:hover {\r\n    scale: 0.99 ;\r\n    background-color:rgb(5, 202, 252);\r\n\r\n }\r\n .post_liked {\r\n    /* transition: 1s ease-in-out; */\r\n    border-radius: 7px;\r\n\r\n     background-color: greenyellow;\r\n     box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(255, 254, 254, 0.3) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\r\n\r\n }\r\n\r\n .post_disliked {\r\n    /* transition: 1s ease-in-out; */\r\n    border-radius: 7px;\r\n\r\n    background-color: rgb(251, 29, 0);\r\n    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(255, 254, 254, 0.3) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\r\n\r\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
